var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"dis-hover":""}},[(_vm.HomeTemplate=='0' || !_vm.HomeTemplate)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../images/flow-chart.png"),"alt":""}}):_c('biReportPreview',{attrs:{"reportName":_vm.HomeTemplate,"noShowRefresh":true}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ba357d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = null
// module chunks = 